import { useContext, useMemo } from 'react'

import { ItemCard } from './ItemCard'
import { QuantitySelector } from './QuantitySelector'
import { ProductContext } from '../../../contexts'

import './styles.scss'

export interface ProductPack {
  skuId: string
  title: string
  subtitle: string
  isPopular: boolean
  packItems: string[]
}

interface AlbumSkuSelectorProps {
  productsPack: ProductPack[]
}
export function AlbumSkuSelector({ productsPack }: AlbumSkuSelectorProps) {
  const { product } = useContext(ProductContext)

  const sortedPacks = useMemo(() => {
    return [...productsPack].sort((a, b) => {
      return Number(b.isPopular) - Number(a.isPopular)
    })
  }, [productsPack])

  return (
    <>
      <div className="w-[calc(100%+16px)] md:w-full max-h-[288px] sku-selector-scroll overflow-x-auto md:overflow-x-visible md:overflow-y-auto snap-x snap-mandatory mt-2">
        <div className="w-full grid grid-rows-2 grid-flow-col md:grid-flow-row md:grid-rows-none md:grid-cols-2 gap-4 pb-4 md:pb-0 md:pr-4">
          {sortedPacks?.map((pack) => {
            const skuItem = product.items.find(
              (item) => item.itemId === pack.skuId
            )

            if (!skuItem) return null

            return (
              <ItemCard
                packInfo={pack}
                sku={skuItem}
                key={`album-selector-${pack.skuId}`}
              />
            )
          })}
        </div>
      </div>
      <div>
        <QuantitySelector productsPack={productsPack} />
      </div>
    </>
  )
}
